export const IS_PRODUCTION = process.env.NODE_ENV !== 'development';

// eslint-disable-next-line no-underscore-dangle
export const WEBPACK_HASH = __webpack_hash__;

/* eslint-disable prefer-destructuring */
export const BUILD_DIRECTORY = process.env.BUILD_DIRECTORY;
/* eslint-enable prefer-destructuring */
